<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 15.5H8V13.8333H3V15.5ZM3 9.66667V11.3333H13V9.66667H3ZM3 5.5V7.16667H18V5.5H3Z" />
</svg>
